module.exports = __webpack_public_path__ + "img/KiCAD_Home_0.0cbb99a4.png";